"use client";

import React from "react";
import CodRefundItems from "../../../components/CodRefundItems";

// Thin view wrapper that delegates to the shared CodRefundItems component.
export default function CodRefundItemsView(props) {
  return <CodRefundItems {...props} />;
}
